/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { SolarPanelFeature } from "./types";

export default function SolarPanel(feature: SolarPanelFeature) {
  this.isNameEditable = () => false;

  return {
    name: "Energy",
    icon: "icon_sunny",
    is_setup: feature.is_setup,
    ...(feature.is_setup
      ? {
          history_chart: feature.history_chart,
          energy_production_current: feature.energy_production_current,
          energy_production_today: feature.energy_production_today,
          energy_production_month: feature.energy_production_month,
          energy_production_lifetime: feature.energy_production_lifetime,
          dollars_saved_today: feature.dollars_saved_today,
          dollars_saved_month: feature.dollars_saved_month,
          dollars_saved_lifetime: feature.dollars_saved_lifetime,
        }
      : null),
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/solar_panel.js